export enum IconWeightType {
    Regular = 'far',
    Solid = 'fas',
    Bold = 'fab',
    Kit = 'kit',
}
